import { TooltipTrigger } from "@visiblethread/react-components";
import { UPLOAD_STATUSES } from "components/Modal/UploadFilesModal/constants";
import { ReactComponent as FailIcon } from "icons/danger.svg";
import { ReactComponent as SuccessIcon } from "icons/green-circle-check.svg";
import { ReactComponent as WaitingIcon } from "icons/grey-circle-dash.svg";
import { ReactComponent as InProgressIcon } from "icons/indexing.svg";

import classes from "./FilesTable.module.scss";

export const getStatusIcon = (fileUploadState) => {
  if (!fileUploadState) {
    return null;
  }

  const { status, error } = fileUploadState;

  switch (status) {
    case UPLOAD_STATUSES.WAITING:
    case UPLOAD_STATUSES.IN_PROGRESS:
      return <InProgressIcon className="in_progress" />;
    case UPLOAD_STATUSES.COMPLETED:
      return <SuccessIcon />;
    case UPLOAD_STATUSES.FAILED:
      return (
        <TooltipTrigger
          content={error}
          classes={classes.error_icon_tooltip_trigger}
        >
          <FailIcon />
        </TooltipTrigger>
      );
    default:
      return <WaitingIcon />;
  }
};

export const isUploading = (fileUploadStates) => {
  const states = Object.values(fileUploadStates);
  if (!states.length) {
    return false;
  }

  for (const { status } of states) {
    if (
      status !== UPLOAD_STATUSES.COMPLETED &&
      status !== UPLOAD_STATUSES.FAILED
    ) {
      return true;
    }
  }

  return false;
};
